import styled from "@emotion/styled";

import Alert from "metabase/core/components/Alert";

export const SameSiteAlert = styled(Alert)`
  display: block;
  padding: 0.75rem;
`;
